module.exports = "<mat-spinner></mat-spinner>"